module.exports = __webpack_public_path__ + "img/training.a8eb3c9e.png";